<template>
    <div class="page">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">{{form.cod ? 'Editar' : 'Cadastrar'}} especialidade</div>
                <div class="right">
                    <a style="opacity: 0" class="link panel-open" data-panel="left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z" fill="black"></path>
                            <path d="M14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1045 10.8954 22 12 22C13.1046 22 14 21.1045 14 20Z" fill="black"></path>
                            <path d="M14 4C14 2.89544 13.1046 2.00001 12 2.00001C10.8954 2.00001 10 2.89544 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>        
        <div class="page-content">

            <div class="container hidden-xs hidden-md">
                <h2>{{form.cod ? 'Editar' : 'Cadastrar'}} especialidades</h2>
            </div>

            <div class="">
                <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                    <div class="list" style="margin-top: 16px">
                        <ul class="row">                        
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nome</div>
                                    <div class="item-input-wrap">
                                        <input type="text" placeholder="Escreva o nome.." v-model="form.nome" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100" v-if="!form.cod">
                                <div class="item-inner">
                                    <div class="item-title item-label">Profissão(ões) <small>(opcional)</small></div>
                                    <div class="item-input-wrap" v-on:click="autocompleteProfissoes()">
                                        <input type="text" placeholder="Toque para selecionar..." readonly="" value="" class="form-control" v-model="profissoes.nomes"/>
                                    </div>
                                </div>
                            </li>                                 
                        </ul>

                        
                    </div>

                    <div class="block">
                        <button type="submit" class="link external button-large button button-fill">
                            <i class="las la-save"></i>
                            Salvar
                        </button>
                    </div>
                </form>

            </div>
        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'GerenciarCategorias',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "categorias": {
                "itens":            []
            },     
            "profissoes": {
                "nomes":            "",
                "valor":            [
                ],
                "itens":            [                 
                ]
            },                        
            "form": {
                "cod":              "",
                "nome":             "",
                "categoriaCod":     "",
                "tipo":             "especialidade"
            }            
        }
    },
    methods: {       
        autocompleteProfissoes: function() {
            var self = this;
            console.log("autocompleteProfissoes()");

            self.autocomplete = window.___app.autocomplete.create({
                // inputEl: '.autocomplete-dropdown-especialidades',
                openIn: 'popup',
                // preloader: true, 
                multiple: true,
                requestSourceOnOpen: true,
                // updateInputValueOnSelect: true,
                closeOnSelect: false,
                valueProperty: 'cod',
                textProperty: 'nome',
                popupCloseLinkText: "Fechar",
                notFoundText: "Nenhum resultado encontrado.",
                searchbarDisableText: "Cancelar",
                searchbarPlaceholder: "Pesquise..",
                value: self.profissoes.valor,
                // limit: 20,
                // typeahead: true,
                // dropdownPlaceholderText: 'Selecione as profissoes..',
                source: function (query, render) {
                    var autocomplete = this;
                    var results = [];
                    autocomplete.preloaderShow();

                    var clean = function(val) {
                        return (val ? val : "").toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim();
                    }

                    var itens = [];                        
                    var search= clean(query);

                    self.profissoes.itens.forEach(function(item) {
                        if ((clean(item.nome).indexOf(search) != -1)) {
                            itens.push(item);
                        }
                    });

                    autocomplete.preloaderHide();
                    render(itens);

                },
                on: {
                    change: function (value) {
                        console.log("change", value);

                        self.profissoes.valor = value;

                        var nomes   = "";
                        var cods   = "";

                        value.forEach(function(item) {
                            nomes += item.nome + ", ";
                            cods += item.cod + ",";
                        });

                        nomes       = nomes.substr(0, nomes.length - 2);
                        cods       = cods.substr(0, cods.length - 1);

                        self.form.categoriaCod  = cods;
                        self.profissoes.nomes = nomes;
                    
                        console.log("Setou categoriaCod", self.form.categoriaCod);

                        self.$forceUpdate();
                    },
                }                
            });

            console.log("autocomplete:", self.autocomplete)

            self.autocomplete.open();

        },          
        getCategorias: function() {
            var self        = this;
            console.log("getCategorias()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "profissao"
                    }
                };

                axios.get("api/categorias.php", form)
                .then(response => {
                    
                    console.log("getCategorias() response", response);
                    self.categorias                     = response.data.result;
                    self.profissoes.itens               = response.data.result.itens;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCategorias() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                           
                });   

            });   
        },            
        submit: function(e) {
            
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/categorias.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                // alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/categorias.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarEspecialidades") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }
    },
    activated: function() {
        var self = this;
        self.getCategorias();
    },       
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
   
    .uploadButton-input {
        position: absolute;
        top: -888888px;
    }
   

</style>



// WEBPACK FOOTER //
// src/components/GerenciarEspecialidades.vue